<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img
            src="../../../assets/images/logo/logo.svg"
            class="logo-size"
          >
        </b-link>
        <div v-if="!renderSuccess">
          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label-for="email"
                label="Email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Email"
                    class="input-color"
                    @focus="errorIsTrue = false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- document -->
              <b-form-group
                label-for="CPF/CNPJ"
                label="CPF/CNPJ"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CPF/CNPJ"
                  rules="required|document"
                >
                  <b-form-input
                    id="CPF/CNPJ"
                    v-model="customerTaxId"
                    v-mask="[
                      '###.###.###-##',
                      '##.###.###/####-##',
                      '##.###.###',
                    ]"
                    name="login-document"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Documento"
                    class="input-color"
                    @focus="errorIsTrue = false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- password -->
              <b-form-group
                label="Senha"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Senha"
                  vid="Password"
                  rules="required|password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge input-color"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                label="Confirmar Senha"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirmar Senha"
                  rules="required|confirmed:Password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="password2FieldType"
                      class="form-control-merge input-color"
                      :state="errors.length > 0 ? false:null"
                      name="reset-password-confirm"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  name="Termos de Uso"
                  rules="requiredCheckbox"
                >
                  <b-form-checkbox
                    v-model="termsAndConditionsCheck"
                    v-b-modal="openModal"
                    data-toggle="modal"
                    data-target="modal-scrollable"
                    data-backdrop="static"
                    data-keyboard="false"
                  >
                    Ao selecionar, você concorda com os
                    <a variant="outline-primary">
                      termos e condições da SoulPay.
                    </a>
                  </b-form-checkbox>
                </validation-provider>
              </b-form-group>
              <b-modal
                id="modal-scrollable"
                hide-backdrop
                no-close-on-backdrop
                size="lg"
                scrollable
                title="Termos e Condições da SoulPay."
                ok-title="Aceitar"
                :ok-disabled="buttonConfirmTermsAndConditions"
                cancel-title="Cancelar"
                @cancel="buttonCancelModal()"
                @close="buttonCancelModal()"
              >
                <terms />
              </b-modal>
              <div
                v-if="errorIsTrue"
                class="text-danger text-center mb-1 mt-1"
              >
                {{ error.message }}
              </div>
              <!-- submit button -->
              <b-button
                variant="primary"
                type="submit"
                block
                :disabled="invalid"
                @click="createUser()"
              >Criar Acesso
              </b-button>
              <b-card-text class="text-center mt-1 text-blue">
                <b-link :to="{ path: '/' }">
                  <span>Voltar</span>
                </b-link>
              </b-card-text>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          <b-row class="d-flex justify-content-center">
            <b-col
              cols="12"
              md="3"
            >
              <icon type="success" />
            </b-col>
            <b-col
              cols="12"
              md="9"
            >
              <div class="text-response">
                <h5>Usuário criado com sucesso</h5>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  BButton,
  BCol,
  BRow,
  BForm,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
  BCard,
  BCardText,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import {
  required,
  email,
} from '@validations'
import {
  togglePasswordVisibility,
} from '@core/mixins/ui/forms'
import { getIpAndBrowser } from '@/service/utilities/fingerprint'

import Ripple from 'vue-ripple-directive'

import Terms from './TermsAndConditions.vue'

import { callLoading, removeDarkMode } from '@/service/utilities/utilities'
import { createPassword } from '@/service/user/user'

import Icon from '@/layouts/components/Icon.vue'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BCol,
    BRow,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BCard,
    BCardText,
    BModal,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Icon,
    Terms,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: null,
      customerTaxId: null,
      password: null,
      cPassword: null,
      status: '',
      required,
      email,
      password1FieldType: 'password',
      password2FieldType: 'password',
      testVar: null,
      termsAndConditionsCheck: false,
      openModal: 'modal-scrollable',
      buttonConfirmTermsAndConditions: true,
      errorIsTrue: false,
      renderSuccess: false,
      error: {
        status: null,
        message: null,
      },
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    termsAndConditionsCheck() {
      this.openModal = this.termsAndConditionsCheck ? null : 'modal-scrollable'

      const modal = document.getElementById('modal-scrollable___BV_modal_body_')

      if (modal === null) return

      modal.addEventListener('scroll', event => {
        const { scrollTop, scrollHeight } = event.target

        if (scrollTop >= scrollHeight - 900) {
          this.buttonConfirmTermsAndConditions = false
        }
      })
    },
  },
  mounted() {
    this.$emit('open', true)
  },
  created() {
    removeDarkMode()
  },
  methods: {
async createUser() {
  callLoading(true)

  const taxId = this.customerTaxId.replace(/[-./]/g, '')
  const { ip, browser } = await getIpAndBrowser()

  const request = {
    email: this.userEmail,
    password: this.password,
    tax_id: taxId,
    terms_agreed: true,
    ip,
    browser,
  }

  try {
    const response = await createPassword(request)

    if (response.status === 200) {
      this.renderSuccess = true
      await new Promise(resolve => setTimeout(resolve, 1550))
      this.$router.push('/')
    } else if (response.status === 422) {
      let errorData = response.data.errors?.[0]
      let field = errorData?.field

      if (!field || !field.trim()) {
        this.error = {
          message: 'Usuário não cadastrado em nossa base de dados.',
        }
        this.errorIsTrue = true
        return
      }

      field = field === 'tax_id' ? 'documento' : field

      this.error = {
        message: `O ${field} inserido não pertence a uma conta. Verifique seu ${field} e tente novamente.`,
      }
      this.errorIsTrue = true
    }

    else {
      this.error = {
        message: 'Esse usuário já está cadastrado',
      }
          this.errorIsTrue = true
        }
      } finally {
        callLoading(false)
      }
    },
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    buttonCancelModal() {
      if (this.buttonConfirmTermsAndConditions || this.termsAndConditionsCheck) {
        this.termsAndConditionsCheck = false
        this.openModal = 'modal-scrollable'
      }
    },
  },
}
</script>

<style scoped lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';

</style>
